import React from "react"
import { SEOHead } from "components/SEO"
import { generateProductPageGraphSchema } from "utils/structuredData"
import AISection from "components/pages/product/AISection"
import BIToolPoweredByApacheSupersetSection from "components/pages/product/BIToolPoweredByApacheSupersetSection"
import FeaturesLockupSection from "components/pages/product/FeaturesLockupSection"
import HeroSection from "components/pages/product/HeroSection"
import ProductHighlightsSection from "components/pages/product/ProductHighlightsSection"
import VisualizationsSection from "components/pages/product/VisualizationsSection"
import DoubleCTASection from "components/ui/Blocks/DoubleCTASection"
import Layout from "components/ui/Layout"

function Product({ location: { pathname } }) {
  return (
    <Layout
      contentSpaced
      trackingName="Product"
      pageName="product"
      pagePath={pathname}
    >
      <HeroSection />
      <BIToolPoweredByApacheSupersetSection />
      <VisualizationsSection />
      <ProductHighlightsSection />
      <AISection />
      <FeaturesLockupSection />
      <DoubleCTASection noBackground trackingName="Product" />
    </Layout>
  )
}

// Export a Head component for Gatsby Head API
export function Head() {
  const graphSchema = generateProductPageGraphSchema({
    pageUrl: "https://preset.io/product/",
    pageTitle: "Preset Cloud - Modern Open Source BI Platform | Preset",
    description:
      "Preset Cloud is a fully hosted cloud service for Apache Superset that helps teams explore data, build dashboards, query with SQL, and deliver analytics at scale.",
    featureList: [
      "Fully hosted cloud service for Apache Superset",
      "Dashboard and chart creation",
      "Collaborative SQL editor",
      "Role-based access control",
      "Row-level security",
      "Multiple workspace deployment",
      "40+ visualization types",
      "AI-powered conversational analytics",
      "SSO support",
      "SOC 2-certified",
    ],
    breadcrumbs: [
      { name: "Home", url: "https://preset.io/" },
      { name: "Product", url: "https://preset.io/product/" },
    ],
  })

  return (
    <SEOHead
      title="Preset Cloud - Modern Open Source BI Platform"
      description="Preset Cloud is a fully managed service for the leading open source BI and visualization platform, Apache Superset™."
      structuredData={[graphSchema]}
    />
  )
}

export default Product
